import './Signup.css';
import Modal from '../../shared/modal/Modal';
import { getSignUpPageTitle } from '../../shared/util/pageTitles';
import { RightPanelContainer } from '../layout/RightPanelContainer';
import { SignupScreen2 } from './departments/SignupScreen2';
import { SignupScreen1 } from './emailAndPassword/SignupScreen1';
import { SignupScreen4 } from './passcode/SignupScreen4';
import { SignupScreen5 } from './SignupScreen5';
import { SignupScreen3 } from './termsAndConditions/SignupScreen3';
import { useSignup } from './useSignup';

export function Signup() {
  const {
    activeScreen,
    clientId,
    departments,
    domainValidation,
    error,
    erv,
    ervFieldName,
    fandf,
    fandFToken,
    isHub,
    isGoogleAuthActive,
    isMicrosoftAuthActive,
    isStandardAuthActive,
    modalIsOpen,
    modalTextContent,
    modalQuestionTitle,
    name,
    regions,
    screenRef,
    singleSignOn,
    subDepartments,
    passcode,
    openModal,
    modalClickHandler,
    setName,
    setUserId,
    handleContinue,
  } = useSignup();

  return (
    <RightPanelContainer page={getSignUpPageTitle(activeScreen)} type="signup">
      {modalIsOpen && (
        <Modal
          modalIsOpen={modalIsOpen}
          onModalClose={modalClickHandler}
          modalText={modalTextContent}
          questionTitle={modalQuestionTitle}
        />
      )}
      <div ref={screenRef} className="signup_screen_container">
        {activeScreen === 1 && (
          <SignupScreen1
            domainValidation={domainValidation}
            fandfUser={fandFToken}
            clientId={clientId}
            handleResponseSSO={(response) => {
              if (response) {
                if (response.user.name !== '' && response.user.name !== null) {
                  setName(response.user.name);
                }
                if (response?.hub) {
                  // Handle hub user
                }
                setUserId(response.user._id);
                // Set other response data...
              }
            }}
            isStandardAuthActive={isStandardAuthActive}
            isMicrosoftAuthActive={isMicrosoftAuthActive}
            isGoogleAuthActive={isGoogleAuthActive}
            singleSignOn={singleSignOn}
            handleContinue={handleContinue}
            error={error}
          />
        )}
        {activeScreen === 2 && (
          <SignupScreen2
            erv={erv}
            name={name}
            ervFieldName={ervFieldName}
            departments={departments}
            subDepartments={subDepartments}
            regions={regions}
            fandf={fandf}
            handleContinue={handleContinue}
            onOpenModal={openModal}
            error={error}
            isHub={isHub}
          />
        )}
        {activeScreen === 3 && <SignupScreen3 error={error} handleContinue={handleContinue} />}
        {activeScreen === 4 && <SignupScreen4 handleContinue={handleContinue} />}
        {activeScreen === 5 && (
          <SignupScreen5 error={error} passcode={passcode} handleContinue={handleContinue} />
        )}
      </div>
    </RightPanelContainer>
  );
}
